import { FormBase } from 'core/components';

export default class FacilityOrderTemplateNewFlowUSIntakeTemplateActivationModalForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: "eligibilityStatusId",
                    label: 'FACILITY_ORDER_TEMPLATE_NEW_FLOW_US_INTAKE.TEMPLATE_ACTIVATION.ELIGIBILITY_STATUS_LABEL',
                    placeholder: 'FACILITY_ORDER_TEMPLATE_NEW_FLOW_US_INTAKE.TEMPLATE_ACTIVATION.ELIGIBILITY_STATUS_PLACEHOLDER',
                    rules: 'required',
                }
            ],
        };
    }
}
